<template>
    <div>
        <wristband-table
            preventDefault
            :items="wristbands"
            :options="pagination"
            @viewDetails="viewWristbandDetails"
            @sort="emitWristbandTableSort"/>

        <right-panel
            hideBottom
            ref="wristbandDetailsRightPanel"
            :title="$t('andamandaPay.pocketDetails.header')">
            <template v-slot:content="{ context }" >
                <wristband-details-view
                    :wristband="context"/>
            </template>
        </right-panel>
    </div>
</template>

<script>
import WristbandTable from '@/components/tables/WristbandTable'
import RightPanel from '@/components/panels/RightPanel'
import WristbandDetailsView from '@/views/WristbandDetailsView'

import { mapGetters } from 'vuex'

export default {
    name: 'WalletListView',

    props: {
        wristbands: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        WristbandTable,
        RightPanel,
        WristbandDetailsView
    },

    computed: {
        ...mapGetters({
            getWristbandById: 'wristband/getWristbandById'
        })
    },

    methods: {
        async viewWristbandDetails (wristbandItem) {
            let wristband = null
            try {
                wristband = await this.getWristbandById(wristbandItem.id)
            } catch (error) {
                const errorHeader = 'Wristband Not Found!'
                const errorMessage = `Not found wristband ${wristbandItem.name}:${wristbandItem.GiftCardNo}`
                console.error(error)
                this.$app.alert(errorHeader, errorMessage)
                return
            }

            this.$refs.wristbandDetailsRightPanel.open(wristband)
        },

        emitWristbandTableSort (sortBy, sortType) {
            this.$emit('wristband:sort', sortBy, sortType)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
